"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("./styles");
exports.Select = function (_a) {
    var label = _a.label, name = _a.name, options = _a.options, value = _a.value, onChange = _a.onChange, otherProps = __rest(_a, ["label", "name", "options", "value", "onChange"]);
    return (react_1.default.createElement(styles_1.Wrapper, __assign({}, otherProps),
        react_1.default.createElement(styles_1.Label, null, label),
        react_1.default.createElement(styles_1.SelectWrapper, null,
            react_1.default.createElement(styles_1.StyledSelect, { name: name, value: value || '', onChange: onChange },
                !value && react_1.default.createElement("option", { value: "", disabled: true }, "Select " + label),
                options.map(getOptionByValue)),
            value ? (react_1.default.createElement(styles_1.SelectLabel, null,
                value,
                react_1.default.createElement(styles_1.Arrow, null))) : (react_1.default.createElement(styles_1.SelectLabelPlaceholder, null, "Select " + label,
                react_1.default.createElement(styles_1.Arrow, null))))));
};
var getOptionByValue = function (value) {
    if (value.key && value.value) {
        return (react_1.default.createElement("option", { key: value.key, value: value.value }, value.value));
    }
    return (react_1.default.createElement("option", { key: value, value: value }, value));
};
//# sourceMappingURL=index.js.map